import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { Subject, debounceTime } from 'rxjs';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class InputComponent {
  @Input()
  appearance: 'fill' | 'outline' = 'outline';

  @Input()
  label: string = '';

  @Input()
  name: string = '';

  @Input()
  icon?: string = '';

  @Input()
  mask?: string = '';

  @Input()
  onChange?: (value: string) => void;

  private searchSubject = new Subject<string>();


  ngOnInit() {
    this.searchSubject
    .pipe(debounceTime(300))
    .subscribe((value) => {
      if (this.onChange) {
        this.onChange(value);
      }
    });
  }

  change(value: string) {
    this.searchSubject.next(value);
  }
}
